const InboxActionTypes = {
  TOGGLE_STAR: "INBOX_TOGGLE_STAR",
  TOGGLE_READ: "INBOX_TOGGLE_READ",
  MARK_AS_READ: "INBOX_MARK_AS_READ",
  DELETE_EMAIL: "INBOX_DELETE_EMAIL",
  UNDO_DELETE: "INBOX_UNDO_DELETE",
  TOGGLE_SELECT: "INBOX_TOGGLE_SELECT",
  SELECT_ALL: "INBOX_SELECT_ALL",
  DESELECT_ALL: "INBOX_DESELECT_ALL",
  BULK_DELETE: "INBOX_BULK_DELETE",
  SET_SEARCH_QUERY: "INBOX_SET_SEARCH_QUERY",
  RESTORE_EMAIL: "INBOX_RESTORE_EMAIL",
  ARCHIVE_EMAIL: "INBOX_ARCHIVE_EMAIL",
  UNDO_ARCHIVE: "INBOX_UNDO_ARCHIVE",
  RESTORE_ARCHIVE: "INBOX_RESTORE_ARCHIVE",
};

export default InboxActionTypes;
